import { render } from "./MediaForm.vue?vue&type=template&id=df0efdb8&scoped=true"
import script from "./MediaForm.vue?vue&type=script&lang=js"
export * from "./MediaForm.vue?vue&type=script&lang=js"

import "./MediaForm.vue?vue&type=style&index=0&id=df0efdb8&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0efdb8"]])

export default __exports__